import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ActivityApi } from 'app/modules/dashboard/api/activity.api';
import { ToasterService } from 'app/services/toaster.service';

@Component({
  imports: [TranslateModule, FormsModule],
  selector: 'app-ts-activity-edit-modal',
  standalone: true,
  styleUrls: [
    './ts-activity-edit-modal.component.scss',
    '../ts-modal.component.scss',
  ],
  template: `
    <body>
      <div class="header">
        <h2 translate>training_log.actions.btn.edit</h2>
      </div>
      <div class="content">
        <label for="status" translate>sharing.editComponent.label.status</label>
        <select
          [(ngModel)]="status"
          name="status-select"
          id="status"
          class="select-box">
          <option value="public">
            {{ 'settings.confidentiality.public' | translate }}
          </option>
          <option value="private">
            {{ 'settings.confidentiality.private' | translate }}
          </option>
        </select>
      </div>

      <div class="footer">
        <button class="btn-primary" (click)="saveClick()">
          {{ 'dashboard.subscription.actions.save' | translate }}
        </button>
        <button class="btn-secondary" (click)="cancelClick.emit()">
          {{ 'dashboard.subscription.titles.cancel' | translate }}
        </button>
      </div>
    </body>
  `,
})
export class TrainingLogActivityEditModalComponent {
  @Input() activityId: string;
  @Input() status: string;

  @Output() cancelClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() updateStatus: EventEmitter<any> = new EventEmitter<any>();

  processing: boolean = false;

  constructor(
    private activityApi: ActivityApi,
    private toasterService: ToasterService,
    private translateService: TranslateService
  ) { }

  saveClick(): void {
    if (this.processing) {
      this.toasterService.warning(
        null,
        this.translateService.instant(
          'training_log.actions.status_update.processing'
        )
      );
    }

    this.processing = true;
    this.activityApi
      .updateActivityStatus(this.activityId.toString(), this.status)
      .subscribe({
        error: (err: HttpErrorResponse): void => {
          console.error(err);
          this.toasterService.error(
            null,
            this.translateService.instant(
              'watch.playlist_modal.toast.add_in_playlist_error'
            )
          );
          this.processing = false;
        },
        next: (): void => {
          this.toasterService.success(
            null,
            this.translateService.instant(
              'training_log.actions.status_update.complete'
            )
          );
          this.updateStatus.emit(this.status);
          this.processing = false;
        },
      });
  }
}
